import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Button, Icon} from 'semantic-ui-react';
import XLSX from 'xlsx';
import {Actions} from '../../common/actions';

const fixdata = (data) => {
  const weight = 10240;
  const maxLength = data.byteLength / weight;
  let output = '';
  for (let length = 0; length < maxLength; ++length) {
    output += String.fromCharCode.apply(null, new Uint8Array(data.slice(length * weight, length * weight + weight)));
  }
  output += String.fromCharCode.apply(null, new Uint8Array(data.slice(output.length)));
  return output;
};

const buildFileSelector = () => {
  const acceptedFiles =
    'application/vnd.ms-excel, application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';
  const fileSelector = document.createElement('input');
  fileSelector.setAttribute('type', 'file');
  fileSelector.setAttribute('multiple', 'multiple');
  fileSelector.setAttribute('accept', acceptedFiles);

  return fileSelector;
};

class Index extends Component {
  constructor(props) {
    super(props);
    this.state = {
      'randomString': '',
      'fileData': null,
      'parsedData': '',
    };

    this.processFile = this.processFile.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleButtonClick = this.handleButtonClick.bind(this);
  }
  
  componentDidMount() {
    this.fileSelector = buildFileSelector();
    this.fileSelector.onchange = this.handleChange;
  }

  handleButtonClick(event) {
    event.preventDefault();
    this.fileSelector.click();
  }

  handleChange(event) {
    this.processFile(event.target.files);
    event.target.value = '';
  }

  processFile(selectorFiles) {
    if (!selectorFiles || selectorFiles.length === 0) {
      return;
    }

    this.props.loadingExcel(true);

    const reader = new FileReader();
    const readAsBinaryString = typeof FileReader !== 'undefined' &&
      FileReader.prototype && FileReader.prototype.readAsBinaryString;
    const f = selectorFiles[0];
    const self = this;

    reader.onload = function(e) {
      let data = e.target.result;
      let wb, arr;
      const readtype = {'type': readAsBinaryString ? 'binary' : 'base64'};
      if (!readAsBinaryString) {
        arr = fixdata(data);
        data = Buffer.from(arr, 'utf8').toString('base64');
      }

      try {
        wb = XLSX.read(data, readtype);
        const firstWorksheet = wb.Sheets[wb.SheetNames[0]];
        const roa = XLSX.utils.sheet_to_json(firstWorksheet, {'header': 1}).filter((row) => row.length > 0);
        self.setState({'parsedData': roa});
        self.props.onGetFile(roa);
      } catch (e) {
        self.props.addMessageBoxError(`${e.name}: ${e.message}`);
      }
    };

    if (readAsBinaryString) {
      reader.readAsBinaryString(f);
    } else {
      reader.readAsArrayBuffer(f);
    }
  }

  render() {
    const {text, saving, disabled} = this.props;
    return (
      <Button
        secondary
        className='download'
        onClick={this.handleButtonClick}
        disabled={disabled || saving}
      >
        <Icon name='upload' />
        <span>{text || 'IMPORTAR'}</span>
      </Button>
    );
  }
}

const mapStateToProps = (state) => {
  return {};
};

const {
  loadingExcel,
  addMessageBoxError,
} = Actions;

export default connect(mapStateToProps, {
  loadingExcel,
  addMessageBoxError,
})(Index);
